angular.module('impactx.catalog').controller('DefaultPictureDialogCtrl', [
    '$scope',
    'TranslationService',
    '$mdDialog',
    'dataGen',
    'ToastService',
    DefaultPictureDialogCtrl]);

function DefaultPictureDialogCtrl($scope, TranslationService, $mdDialog, dataGen, ToastService) {
    let self = this;
    self.attachments = {};

    $scope.trns = {
        abort: TranslationService.get('abort'),
        apply: TranslationService.get('accept')
    };

    dataGen.getData($scope, {catId: self.catId, proIds: self.proIds}, "/product/defaultpicture/view");

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.changeDefaultImage = function () {
        var formData = $scope.data;
        formData.catId = self.catId;
        formData.proIds = self.proIds;

        dataGen.postAsForm($scope, {formData: formData}, '/product/defaultpicture/apply').then(function () {
            ToastService.openStandardToast($scope.trns.successMessage);
            $mdDialog.hide();
        });
    };
}